export default $axios => ({
  fetch() {
    return $axios.$get('/v2/instagram-stories')
  },
  track(params) {
    return $axios.$post('/instagram-story-events', params)
  },
  getServiceName: () => 'instagramStoriesService',
})
